import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { useAuth, API } from "../lib/auth";

export default function NotificationBell() {
  const { authHeader, user } = useAuth();
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const load = async () => {
    try {
      const r = await axios.get(`${API}/notifications`, { headers: authHeader });
      setItems(r.data.items || []);
      setUnread(r.data.unread || 0);
    } catch (e) {}
  };

  useEffect(() => {
    if (!user) return;
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
    // eslint-disable-next-line
  }, [user]);

  const markAll = async () => {
    await axios.post(`${API}/notifications/read-all`, {}, { headers: authHeader });
    load();
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="notif-bell" aria-label="Notifications" className="relative p-2 rounded-full hover:bg-slate-100 text-slate-700">
          <Bell className="h-5 w-5" />
          {unread > 0 && (
            <span className="absolute top-1 right-1 h-4 min-w-4 px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center">{unread}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between">
          <span className="font-semibold text-slate-900">Notifications</span>
          <button onClick={markAll} className="text-xs text-[#1A8FE3] hover:underline" data-testid="notif-mark-all">Mark all read</button>
        </div>
        <div className="max-h-80 overflow-y-auto">
          {items.length === 0 ? (
            <div className="px-4 py-8 text-center text-sm text-slate-500">No notifications</div>
          ) : items.map(n => (
            <Link key={n.id} to={n.link || "#"} data-testid={`notif-${n.id}`} className={`block px-4 py-3 border-b border-slate-50 hover:bg-slate-50 ${!n.read ? "bg-sky-50/40" : ""}`}>
              <div className="text-sm font-medium text-slate-900">{n.title}</div>
              {n.body && <div className="text-xs text-slate-500 mt-1 line-clamp-2">{n.body}</div>}
              <div className="text-[10px] text-slate-400 mt-1">{new Date(n.created_at).toLocaleString()}</div>
            </Link>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
